/* THE HONEY SQUAD v2 — interactions, intro, music, Buzz chat, cart */
(function () {
  'use strict';
  var T = window.theme || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function store(k, v) { try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function waLink(text) { return 'https://wa.me/' + (T.whatsapp || '') + (text ? '?text=' + encodeURIComponent(text) : ''); }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || 'Rs.{{amount}}';
    var v = cents / 100;
    var d = function (n, p) { var a = n.toFixed(p).split('.'); a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); return a.join('.'); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) return d(v, 0);
      return d(v, 2);
    }).replace('.00', '');
  }

  /* ---------- product data ---------- */
  function P() { return window.HSproduct || { variants: [] }; }
  function variantBy(title) {
    var vs = P().variants; title = String(title || '').toLowerCase();
    for (var i = 0; i < vs.length; i++) if (String(vs[i].title).toLowerCase().indexOf(title) > -1) return vs[i];
    return vs[0];
  }

  /* ---------- loaded ---------- */
  function markLoaded() { document.documentElement.classList.add('is-loaded'); }
  if (document.readyState === 'complete') setTimeout(markLoaded, 100); else window.addEventListener('load', function () { setTimeout(markLoaded, 100); });
  setTimeout(markLoaded, 2200);

  /* ---------- header & nav ---------- */
  var header = $('.site-header');
  function onScroll() { if (header) header.classList.toggle('is-scrolled', window.scrollY > 30); }
  window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  var mnav = $('.mobile-nav');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { if (mnav) mnav.classList.add('is-open'); }); });
  $$('[data-menu-close], .mobile-nav a').forEach(function (b) { b.addEventListener('click', function () { if (mnav) mnav.classList.remove('is-open'); }); });

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = e.target.getAttribute('data-delay'); if (d) e.target.style.transitionDelay = d + 'ms';
        e.target.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  } else { $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- story honey line ---------- */
  var story = $('[data-story]');
  if (story) {
    var st = function () {
      var r = story.getBoundingClientRect();
      var p = (window.innerHeight * 0.6 - r.top) / r.height;
      story.style.setProperty('--p', Math.max(0, Math.min(1, p)).toFixed(3));
    };
    window.addEventListener('scroll', st, { passive: true }); st();
  }

  /* ---------- 3D tilt ---------- */
  $$('[data-tilt]').forEach(function (el) {
    if (reduce) return;
    var wrap = el.parentElement;
    wrap.addEventListener('pointermove', function (e) {
      var r = wrap.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
      el.style.transform = 'rotateY(' + (x * 16) + 'deg) rotateX(' + (-y * 12) + 'deg)';
    });
    wrap.addEventListener('pointerleave', function () { el.style.transform = ''; });
  });

  /* ---------- vibes tabs ---------- */
  $$('.vibe-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var list = tab.parentElement;
      $$('.vibe-tab', list).forEach(function (t) {
        var on = t === tab; t.setAttribute('aria-selected', on);
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) { p.hidden = !on; if (on) { p.classList.remove('is-anim'); void p.offsetWidth; p.classList.add('is-anim'); } }
      });
    });
  });

  /* ---------- fact flip ---------- */
  $$('.fact').forEach(function (f) {
    f.addEventListener('click', function () { var on = f.classList.toggle('is-flipped'); f.setAttribute('aria-pressed', on); });
  });

  /* =========================================================
     MUSIC: upbeat pop-rock loop synthesised live with Web Audio
     (no audio file needed; a custom MP3 can be set in theme settings)
     ========================================================= */
  var Music = (function () {
    var ctx, master, delayIn, noise, shaper, timer, step = 0, nextT = 0, loops = 0, on = false, ducked = false, file = null;
    var BPM = 126, S16 = 60 / BPM / 4, VOL = 0.5;
    var ROOTS = [130.81, 98.0, 110.0, 87.31]; /* C3 G2 A2 F2 (I - V - vi - IV) */
    var LEAD = [
      [[0, 659.25, 2], [2, 783.99, 2], [4, 880, 2], [6, 783.99, 2], [8, 659.25, 3], [11, 587.33, 1], [12, 523.25, 4]],
      [[0, 587.33, 2], [2, 783.99, 2], [4, 880, 2], [6, 783.99, 2], [8, 587.33, 4], [12, 659.25, 2], [14, 587.33, 2]],
      [[0, 659.25, 2], [2, 880, 2], [4, 1046.5, 2], [6, 880, 2], [8, 783.99, 2], [10, 659.25, 2], [12, 880, 4]],
      [[0, 698.46, 2], [2, 880, 2], [4, 1046.5, 2], [6, 880, 2], [8, 783.99, 3], [11, 698.46, 1], [12, 659.25, 2], [14, 587.33, 2]]
    ];
    function init() {
      var AC = window.AudioContext || window.webkitAudioContext; if (!AC) return false;
      ctx = new AC();
      master = ctx.createGain(); master.gain.value = 0.0001;
      var comp = ctx.createDynamicsCompressor(); comp.threshold.value = -14; comp.ratio.value = 4;
      master.connect(comp); comp.connect(ctx.destination);
      delayIn = ctx.createDelay(); delayIn.delayTime.value = S16 * 3;
      var fb = ctx.createGain(); fb.gain.value = 0.32; var wet = ctx.createGain(); wet.gain.value = 0.28;
      delayIn.connect(fb); fb.connect(delayIn); delayIn.connect(wet); wet.connect(master);
      noise = ctx.createBuffer(1, ctx.sampleRate, ctx.sampleRate);
      var d = noise.getChannelData(0); for (var i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
      shaper = ctx.createWaveShaper(); var n = 2048, c = new Float32Array(n), k = 40;
      for (var j = 0; j < n; j++) { var x = j * 2 / n - 1; c[j] = (3 + k) * x * 0.35 / (Math.PI + k * Math.abs(x)); }
      shaper.curve = c; var gl = ctx.createBiquadFilter(); gl.type = 'lowpass'; gl.frequency.value = 2600;
      var gv = ctx.createGain(); gv.gain.value = 0.55; shaper.connect(gl); gl.connect(gv); gv.connect(master);
      return true;
    }
    function env(g, t, a, peak, dur) { g.gain.setValueAtTime(0.0001, t); g.gain.exponentialRampToValueAtTime(peak, t + a); g.gain.exponentialRampToValueAtTime(0.0001, t + dur); }
    function kick(t) { var o = ctx.createOscillator(), g = ctx.createGain(); o.frequency.setValueAtTime(160, t); o.frequency.exponentialRampToValueAtTime(42, t + 0.13); env(g, t, 0.003, 1.0, 0.32); o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.35); }
    function noiseHit(t, type, freq, peak, dur) { var s = ctx.createBufferSource(); s.buffer = noise; var f = ctx.createBiquadFilter(); f.type = type; f.frequency.value = freq; var g = ctx.createGain(); env(g, t, 0.002, peak, dur); s.connect(f); f.connect(g); g.connect(master); s.start(t); s.stop(t + dur + 0.02); }
    function snare(t) { noiseHit(t, 'highpass', 1400, 0.5, 0.2); var o = ctx.createOscillator(), g = ctx.createGain(); o.type = 'triangle'; o.frequency.value = 196; env(g, t, 0.002, 0.3, 0.1); o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.12); }
    function hat(t, open) { noiseHit(t, 'highpass', 8500, open ? 0.14 : 0.1, open ? 0.14 : 0.04); }
    function bass(t, f, dur) { var o = ctx.createOscillator(), fl = ctx.createBiquadFilter(), g = ctx.createGain(); o.type = 'sawtooth'; o.frequency.value = f; fl.type = 'lowpass'; fl.frequency.setValueAtTime(900, t); fl.frequency.exponentialRampToValueAtTime(220, t + dur); fl.Q.value = 6; env(g, t, 0.005, 0.32, dur); o.connect(fl); fl.connect(g); g.connect(master); o.start(t); o.stop(t + dur + 0.02); }
    function guitar(t, f, dur) { [1, 1.5, 2].forEach(function (m, i) { var o = ctx.createOscillator(), g = ctx.createGain(); o.type = 'sawtooth'; o.frequency.value = f * m; o.detune.value = i * 6 - 6; env(g, t, 0.004, 0.16, dur); o.connect(g); g.connect(shaper); o.start(t); o.stop(t + dur + 0.02); }); }
    function lead(t, f, dur) { var o = ctx.createOscillator(), o2 = ctx.createOscillator(), fl = ctx.createBiquadFilter(), g = ctx.createGain(); o.type = 'square'; o2.type = 'sawtooth'; o.frequency.value = f; o2.frequency.value = f * 1.004; fl.type = 'lowpass'; fl.frequency.value = 3200; env(g, t, 0.01, 0.07, dur); o.connect(fl); o2.connect(fl); fl.connect(g); g.connect(master); g.connect(delayIn); o.start(t); o2.start(t); o.stop(t + dur + 0.05); o2.stop(t + dur + 0.05); }
    function play(s, t) {
      var bar = Math.floor(s / 16) % 4, i = s % 16, R = ROOTS[bar];
      if (i % 4 === 0 || (bar === 3 && i === 14)) kick(t);
      if (i === 4 || i === 12) snare(t);
      if (loops > 0 && bar === 3 && (i === 13 || i === 15)) snare(t);
      if (i % 2 === 0) hat(t, i === 14);
      if (i % 2 === 0) bass(t, (i === 6 || i === 14) ? R / 2 : R / 4, S16 * 1.8);
      if (loops > 0 && [0, 3, 6, 10, 12].indexOf(i) > -1) guitar(t, R, S16 * 1.6);
      if (loops > 0) LEAD[bar].forEach(function (n) { if (n[0] === i) lead(t, n[1], n[2] * S16 * 0.95); });
    }
    function tick() {
      while (nextT < ctx.currentTime + 0.15) {
        play(step, nextT); nextT += S16; step++;
        if (step >= 64) { step = 0; loops++; }
      }
    }
    function setVol(v, sec) {
      if (file) { file.volume = Math.max(0, Math.min(1, v * 1.6)); return; }
      if (!master) return; var t = ctx.currentTime;
      master.gain.cancelScheduledValues(t); master.gain.setValueAtTime(Math.max(master.gain.value, 0.0001), t);
      master.gain.exponentialRampToValueAtTime(Math.max(v, 0.0001), t + (sec || 0.4));
    }
    function ui() {
      $$('[data-music-toggle]').forEach(function (b) {
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
        var l = $('[data-music-label]', b); if (l) l.textContent = on ? 'Music on' : 'Play music';
      });
    }
    var btn = $('[data-music-toggle]');
    var src = btn ? btn.getAttribute('data-src') : '';
    return {
      start: function () {
        if (on || !btn) return;
        if (src) {
          if (!file) { file = new Audio(src); file.loop = true; }
          file.volume = 0.6; var p = file.play(); if (p && p.catch) p.catch(function () {});
        } else {
          if (!ctx && !init()) return;
          if (ctx.resume) ctx.resume();
          nextT = ctx.currentTime + 0.05; step = 0; loops = 0;
          clearInterval(timer); timer = setInterval(tick, 25);
          setVol(ducked ? VOL * 0.3 : VOL, 0.6);
        }
        on = true; ui();
      },
      stop: function () {
        if (!on) return; on = false; ui();
        if (file) { file.pause(); return; }
        setVol(0.0001, 0.3); setTimeout(function () { if (!on) clearInterval(timer); }, 350);
      },
      toggle: function () { if (on) this.stop(); else this.start(); },
      duck: function (d) { ducked = d; if (on) setVol(d ? VOL * 0.3 : VOL, 0.4); }
    };
  })();
  window.HSMusic = Music;
  $$('[data-music-toggle]').forEach(function (b) { b.addEventListener('click', function () { Music.toggle(); }); });

  /* ---------- video sound toggles ---------- */
  $$('video').forEach(function (v) { v.muted = true; var p = v.play && v.play(); if (p && p.catch) p.catch(function () {}); });
  $$('[data-sound-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = $('video', b.parentElement); if (!v) return;
      var turnOn = v.muted;
      $$('video').forEach(function (o) { o.muted = true; });
      $$('[data-sound-toggle]').forEach(function (o) { o.textContent = '🔇 Sound'; o.setAttribute('aria-pressed', 'false'); });
      if (turnOn) { v.muted = false; v.currentTime = 0; v.play(); b.textContent = '🔊 On'; b.setAttribute('aria-pressed', 'true'); Music.duck(true); }
      else Music.duck(false);
    });
  });

  /* =========================================================
     INTRO: Buzz the bee welcomes visitors
     ========================================================= */
  var intro = $('#Intro');
  if (intro) {
    var every = intro.getAttribute('data-every') === 'true';
    if (every || !store('hs-intro')) {
      intro.hidden = false; document.body.classList.add('no-scroll');
      var words = $$('.w', intro), started = false, closed = false;
      words.forEach(function (w, i) { setTimeout(function () { if (!started) w.classList.add('on'); }, 1300 + i * 140); });
      confetti($('.intro__confetti', intro));
      var finish = function () {
        intro.classList.add('is-leaving'); document.body.classList.remove('no-scroll');
        setTimeout(function () { intro.hidden = true; }, 700);
      };
      var flyBee = function () {
        var bee = $('.intro__bee', intro), target = $('.header__logo img') || $('.header__logo');
        if (!bee || !target) return finish();
        var a = bee.getBoundingClientRect(), b = target.getBoundingClientRect();
        var clone = bee.cloneNode(); clone.className = 'bee-fly';
        clone.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px;';
        document.body.appendChild(clone);
        intro.classList.add('is-flying'); bee.style.visibility = 'hidden';
        requestAnimationFrame(function () { requestAnimationFrame(function () {
          var sc = b.height / a.height;
          clone.style.transformOrigin = '0 0';
          clone.style.transform = 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px) scale(' + sc + ') rotate(-360deg)';
          clone.style.opacity = '0';
        }); });
        setTimeout(finish, 450);
        setTimeout(function () { clone.remove(); var logo = $('.header__logo img'); if (logo && logo.animate) logo.animate([{ transform: 'scale(1.5) rotate(-12deg)' }, { transform: 'none' }], { duration: 600, easing: 'cubic-bezier(.3,1.6,.45,1)' }); }, 1150);
      };
      var close = function (fly) {
        if (closed) return; closed = true; store('hs-intro', '1');
        if (window.speechSynthesis) try { window.speechSynthesis.cancel(); } catch (e) {}
        Music.duck(false);
        if (fly && !reduce) flyBee(); else finish();
      };
      var go = function () {
        if (started) return; started = true;
        intro.classList.add('is-talking');
        Music.start(); Music.duck(true);
        words.forEach(function (w) { w.classList.remove('on'); });
        var line = intro.getAttribute('data-line') || '';
        var voiceUrl = intro.getAttribute('data-voice');
        var light = function (idx) { words.forEach(function (w, i) { w.classList.toggle('on', i <= idx); w.classList.toggle('hl', i === idx); }); };
        var timed = function (total) { words.forEach(function (w, i) { setTimeout(function () { light(i); }, i * total / words.length); }); };
        var finished = false;
        var done = function () { if (finished) return; finished = true; light(words.length - 1); setTimeout(function () { close(true); }, 900); };
        if (voiceUrl) {
          var au = new Audio(voiceUrl); au.onloadedmetadata = function () { timed((au.duration || 4) * 1000); };
          au.onended = done; au.onerror = function () { timed(4200); setTimeout(done, 4400); };
          var pp = au.play(); if (pp && pp.catch) pp.catch(function () { timed(4200); setTimeout(done, 4400); });
        } else if (window.speechSynthesis && window.SpeechSynthesisUtterance) {
          var u = new SpeechSynthesisUtterance(line);
          var vs = window.speechSynthesis.getVoices() || [];
          var pref = ['Google UK English Female', 'Samantha', 'Microsoft Aria', 'Microsoft Zira', 'Google US English', 'Karen', 'Tessa'];
          var pick = null;
          for (var i = 0; i < pref.length && !pick; i++) for (var j = 0; j < vs.length; j++) if (vs[j].name.indexOf(pref[i]) > -1) { pick = vs[j]; break; }
          if (!pick) for (var k = 0; k < vs.length; k++) if (/^en/i.test(vs[k].lang)) { pick = vs[k]; break; }
          if (pick) u.voice = pick;
          u.pitch = 1.55; u.rate = 1.0; u.volume = 1;
          var bounded = false;
          var starts = [], acc = 0; words.forEach(function (w) { starts.push(acc); acc += w.textContent.length + 1; });
          u.onboundary = function (ev) { bounded = true; var idx = 0; for (var n = 0; n < starts.length; n++) if (ev.charIndex >= starts[n]) idx = n; light(idx); };
          u.onstart = function () { setTimeout(function () { if (!bounded) timed(Math.max(3200, line.length * 62)); }, 400); };
          u.onend = done;
          u.onerror = function () { timed(3800); setTimeout(done, 4000); };
          try { window.speechSynthesis.cancel(); window.speechSynthesis.speak(u); } catch (e) { timed(3800); setTimeout(done, 4000); }
          setTimeout(done, 11000);
        } else { timed(3800); setTimeout(done, 4000); }
      };
      intro.addEventListener('click', function (e) {
        if (e.target.closest('[data-intro-skip]')) { e.stopPropagation(); close(false); return; }
        go();
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !closed) close(false); });
    }
  }
  function confetti(cv) {
    if (!cv || reduce) return;
    var ctx = cv.getContext('2d'), W, H, ps = [], cols = ['#ffd000', '#ff2e93', '#1ec8f7', '#8edc26', '#ffffff', '#ff7a00'];
    function size() { W = cv.width = cv.clientWidth; H = cv.height = cv.clientHeight; }
    size(); window.addEventListener('resize', size);
    for (var i = 0; i < 110; i++) ps.push({ x: Math.random() * W, y: Math.random() * -H, w: 6 + Math.random() * 8, h: 8 + Math.random() * 10, vy: 1.2 + Math.random() * 2.4, vx: (Math.random() - .5) * 1.2, r: Math.random() * 6, vr: (Math.random() - .5) * .2, c: cols[i % cols.length], hex: Math.random() < .25 });
    (function f() {
      if (cv.closest('[hidden]')) return;
      ctx.clearRect(0, 0, W, H);
      ps.forEach(function (p) {
        p.y += p.vy; p.x += p.vx + Math.sin(p.y / 40) * .4; p.r += p.vr; if (p.y > H + 20) { p.y = -20; p.x = Math.random() * W; }
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r); ctx.fillStyle = p.c;
        if (p.hex) { ctx.beginPath(); for (var k = 0; k < 6; k++) { var a = k * Math.PI / 3; ctx.lineTo(Math.cos(a) * p.w * .8, Math.sin(a) * p.w * .8); } ctx.fill(); }
        else ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });
      requestAnimationFrame(f);
    })();
  }

  /* =========================================================
     CART
     ========================================================= */
  var drawer = $('#CartDrawer');
  var mock = T.preview ? { items: [], total_price: 0, item_count: 0 } : null;
  var R = T.routes || { cart: '/cart', cart_add: '/cart/add', cart_change: '/cart/change' };
  function api(url, body) {
    if (mock) return Promise.resolve(mockApi(url, body));
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function mockApi(url, body) {
    if (url.indexOf('add') > -1) {
      body.items.forEach(function (it) {
        var v = (T.mockVariants || {})[it.id]; if (!v) return;
        var ex = mock.items.filter(function (i) { return i.id == it.id; })[0];
        if (ex) ex.quantity += it.quantity;
        else mock.items.push({ id: v.id, key: 'k' + v.id, quantity: it.quantity, price: v.price, product_title: v.product_title, variant_title: v.title, image: v.image, url: '#' });
      });
    } else if (url.indexOf('change') > -1) {
      mock.items = mock.items.map(function (i) { if (i.key === body.id) i.quantity = body.quantity; return i; }).filter(function (i) { return i.quantity > 0; });
    }
    mock.item_count = 0; mock.total_price = 0;
    mock.items.forEach(function (i) { i.final_line_price = i.price * i.quantity; mock.item_count += i.quantity; mock.total_price += i.final_line_price; });
    return JSON.parse(JSON.stringify(mock));
  }
  function meter(total, threshold, cls, done, todo) {
    if (!threshold) return '';
    var pct = Math.min(100, Math.round(total / threshold * 100)), left = threshold - total;
    return '<div class="ship-meter ' + cls + '">' + (left <= 0 ? done : todo.replace('[amount]', '<b>' + formatMoney(left) + '</b>')) + '<div class="ship-meter__bar"><div class="ship-meter__fill" style="width:' + pct + '%"></div></div></div>';
  }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count || ''; c.setAttribute('data-count', cart.item_count); });
    if (!drawer) return;
    var body = $('[data-cart-body]', drawer), foot = $('[data-cart-foot]', drawer);
    var khi = (T.freeKarachi || 0) * 100, pk = (T.freePakistan || 0) * 100;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="big">🍯</div><p>Your jar is empty. Let\'s fix that!</p><a class="btn btn--honey" href="' + (T.shopUrl || '#shop') + '" data-cart-close>Shop honey</a></div>';
      foot.hidden = true; bindClose(); return;
    }
    var html = meter(cart.total_price, khi, 'ship-meter--khi', '🎉 <b>Free delivery in Karachi</b> unlocked!', '🚚 Add [amount] more for <b>free delivery in Karachi</b>') +
      meter(cart.total_price, pk, 'ship-meter--pk', '🎉 <b>Free delivery across Pakistan</b> unlocked!', '📦 Add [amount] more for <b>free delivery across Pakistan</b>');
    cart.items.forEach(function (i) {
      var img = i.image ? (T.preview ? i.image : i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
      html += '<div class="line-item">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="80" height="80">' : '<span></span>') +
        '<div><div class="line-item__title">' + i.product_title + '</div>' +
        (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="line-item__meta">' + i.variant_title + '</div>' : '') +
        '<div class="qty" data-key="' + i.key + '"><button type="button" data-q="-1" aria-label="Decrease">−</button><input type="number" min="0" value="' + i.quantity + '" aria-label="Quantity"><button type="button" data-q="1" aria-label="Increase">+</button></div>' +
        '<button class="line-item__remove" type="button" data-remove="' + i.key + '">Remove</button></div>' +
        '<div class="line-item__price">' + formatMoney(i.final_line_price) + '</div></div>';
    });
    body.innerHTML = html; foot.hidden = false;
    $('[data-cart-total]', foot).textContent = formatMoney(cart.total_price);
    $$('.qty', body).forEach(function (q) {
      var key = q.getAttribute('data-key'), input = $('input', q);
      $$('button', q).forEach(function (b) { b.addEventListener('click', function () { change(key, Math.max(0, +input.value + +b.getAttribute('data-q'))); }); });
      input.addEventListener('change', function () { change(key, Math.max(0, +input.value)); });
    });
    $$('[data-remove]', body).forEach(function (b) { b.addEventListener('click', function () { change(b.getAttribute('data-remove'), 0); }); });
    var a = $('[data-wa-cart]');
    if (a) {
      var lines = cart.items.map(function (i) { return '• ' + i.quantity + ' × ' + i.product_title + (i.variant_title ? ' (' + i.variant_title + ')' : ''); }).join('\n');
      a.href = waLink('Assalam o Alaikum! I want to order:\n' + lines + '\nTotal: ' + formatMoney(cart.total_price) + '\nName:\nCity:\nAddress:');
    }
  }
  function change(key, qty) { api(R.cart_change + '.js', { id: key, quantity: qty }).then(renderCart); }
  function openCart() { if (!drawer) { location.href = R.cart; return; } drawer.classList.add('is-open'); document.body.classList.add('no-scroll'); }
  function closeCart() { if (drawer) drawer.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
  function bindClose() { $$('[data-cart-close]').forEach(function (b) { b.onclick = function (e) { if (b.tagName !== 'A') e.preventDefault(); closeCart(); }; }); }
  bindClose();
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); api(R.cart + '.js').then(renderCart); openCart(); }); });
  if (!mock) api(R.cart + '.js').then(renderCart).catch(function () {});
  function addItems(items, fromEl) {
    items = items.filter(function (i) { return i.id && i.quantity > 0; });
    if (!items.length) return Promise.resolve();
    return api(R.cart_add + '.js', { items: items })
      .then(function () { return api(R.cart + '.js'); })
      .then(function (cart) { renderCart(cart); openCart(); if (fromEl) burst(fromEl); })
      .catch(function (err) { if (window.console) console.warn(err); });
  }
  window.HSaddItems = addItems;

  /* product form */
  $$('[data-product-form]').forEach(function (form) {
    var scope = form.closest('[data-product]') || document;
    var priceEl = $('[data-price]', scope), cmpEl = $('[data-compare]', scope);
    var idInput = $('input[name="id"]', form), qtyInput = $('input[name="quantity"]', form);
    var wa = $('[data-wa-product]', form), btn = $('[type="submit"]', form);
    function sync() {
      var c = $('input[name="variant-pick"]:checked', form); if (!c) return;
      idInput.value = c.value;
      if (priceEl) priceEl.textContent = formatMoney(+c.getAttribute('data-price'));
      if (cmpEl) { var cp = +c.getAttribute('data-compare'); cmpEl.textContent = cp > +c.getAttribute('data-price') ? formatMoney(cp) : ''; }
      var avail = c.getAttribute('data-available') !== 'false';
      btn.disabled = !avail; $('span', btn).textContent = avail ? 'Add to cart' : 'Sold out';
      if (wa) wa.href = waLink('Assalam o Alaikum! I want to order ' + qtyInput.value + ' × ' + form.getAttribute('data-title') + ' (' + c.getAttribute('data-label') + ').\nName:\nCity:\nAddress:');
      var gal = $('[data-gallery-main]'), img = c.getAttribute('data-image');
      if (gal && img) { gal.src = img; gal.removeAttribute('srcset'); }
      if (!T.preview && history.replaceState && document.body.classList.contains('template-product')) { var u = new URL(location.href); u.searchParams.set('variant', c.value); history.replaceState({}, '', u); }
    }
    $$('input[name="variant-pick"]', form).forEach(function (r) { r.addEventListener('change', sync); });
    $$('[data-qty]', form).forEach(function (b) { b.addEventListener('click', function () { qtyInput.value = Math.max(1, +qtyInput.value + +b.getAttribute('data-qty')); sync(); }); });
    qtyInput.addEventListener('change', sync); sync();
    form.addEventListener('submit', function (e) {
      e.preventDefault(); btn.disabled = true;
      addItems([{ id: +idInput.value, quantity: +qtyInput.value }], btn).then(function () { btn.disabled = false; });
    });
  });

  /* quick add (vibes) */
  $$('[data-quick-add]').forEach(function (b) {
    b.addEventListener('click', function () { var v = variantBy(b.getAttribute('data-quick-add')); if (v) addItems([{ id: v.id, quantity: +b.getAttribute('data-qty') || 1 }], b); });
  });

  function burst(el) {
    if (reduce || !el) return;
    var r = el.getBoundingClientRect();
    for (var i = 0; i < 20; i++) {
      var d = document.createElement('span'), s = 8 + Math.random() * 10;
      d.style.cssText = 'position:fixed;z-index:90;pointer-events:none;border-radius:50% 50% 50% 0;width:' + s + 'px;height:' + s + 'px;left:' + (r.left + r.width / 2) + 'px;top:' + (r.top + r.height / 2) + 'px;background:' + ['#ffd000', '#ff2e93', '#1ec8f7', '#8edc26'][i % 4] + ';border:2px solid #1c0a2e;transition:transform .9s cubic-bezier(.2,.8,.2,1),opacity .9s';
      document.body.appendChild(d);
      (function (d) {
        requestAnimationFrame(function () { var a = Math.random() * 6.28, dist = 60 + Math.random() * 120; d.style.transform = 'translate(' + Math.cos(a) * dist + 'px,' + (Math.sin(a) * dist - 40) + 'px) rotate(' + Math.random() * 360 + 'deg)'; d.style.opacity = '0'; });
        setTimeout(function () { d.remove(); }, 1000);
      })(d);
    }
  }

  /* gallery thumbs */
  $$('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = $('[data-gallery-main]'); if (main) { main.src = b.getAttribute('data-thumb'); main.removeAttribute('srcset'); }
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b); });
    });
  });

  /* =========================================================
     SIZE FINDER
     ========================================================= */
  var finder = $('[data-finder]');
  if (finder) {
    var people = $('[data-people]', finder), out = $('[data-people-out]', finder), freq = 'daily', plan = [];
    var g = { sometimes: +finder.getAttribute('data-g-sometimes') || 80, daily: +finder.getAttribute('data-g-daily') || 250, lots: +finder.getAttribute('data-g-lots') || 450 };
    var calc = function () {
      out.textContent = people.value;
      var need = +people.value * g[freq], n5 = Math.floor(need / 500), rem = need - n5 * 500, n2 = 0;
      if (rem > 250) n5++; else if (rem > 0) n2 = 1;
      if (!n5 && !n2) n2 = 1;
      var v2 = variantBy('250'), v5 = variantBy('500');
      var total = n5 * (v5 ? v5.price : 110000) + n2 * (v2 ? v2.price : 55000);
      plan = []; if (n5) plan.push({ id: v5 && v5.id, quantity: n5 }); if (n2) plan.push({ id: v2 && v2.id, quantity: n2 });
      var parts = []; if (n5) parts.push(n5 + ' × 500g'); if (n2) parts.push(n2 + ' × 250g');
      $('[data-finder-big]', finder).textContent = parts.join(' + ');
      var bt = ''; for (var i = 0; i < Math.min(n5, 14); i++) bt += '<i style="animation-delay:' + i * 60 + 'ms"></i>'; if (n2) bt += '<i class="small"></i>';
      $('[data-finder-bottles]', finder).innerHTML = bt;
      var khi = (T.freeKarachi || 0) * 100, pk = (T.freePakistan || 0) * 100, msg = 'About ' + need + 'g a month · Total <b>' + formatMoney(total) + '</b>. ';
      if (pk && total >= pk) msg += '🎉 <b>Free delivery anywhere in Pakistan!</b>';
      else if (khi && total >= khi) msg += '🎉 <b>Free delivery in Karachi!</b> Add ' + formatMoney(pk - total) + ' more for free delivery nationwide.';
      else if (khi) msg += 'Add ' + formatMoney(khi - total) + ' more for free delivery in Karachi.';
      $('[data-finder-note]', finder).innerHTML = msg;
    };
    people.addEventListener('input', calc);
    $$('[data-freq]', finder).forEach(function (b) { b.addEventListener('click', function () { freq = b.getAttribute('data-freq'); $$('[data-freq]', finder).forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); calc(); }); });
    $('[data-finder-add]', finder).addEventListener('click', function (e) { addItems(plan, e.currentTarget); });
    calc();
  }

  /* =========================================================
     BUZZ: the honey helper chat (instant answers, WhatsApp hand-off)
     ========================================================= */
  var Chat = (function () {
    var box = $('#Chat'); if (!box) return { open: function () {}, close: function () {} };
    var log = $('[data-chat-log]', box), form = $('[data-chat-form]', box), input = $('input', form), greeted = false;
    var name = box.getAttribute('data-name') || 'Buzz';
    var fee = T.deliveryFee ? formatMoney(T.deliveryFee * 100) : '';
    function prices() { return P().variants.map(function (v) { return v.title + ' = ' + formatMoney(v.price); }).join(' · '); }
    function addActs() { return P().variants.map(function (v) { return { add: v.title, label: '🛒 Add ' + v.title }; }); }
    var K = T.freeKarachi ? formatMoney(T.freeKarachi * 100) : '', PK = T.freePakistan ? formatMoney(T.freePakistan * 100) : '';
    var intents = [
      { k: ['hi', 'hello', 'hey', 'salam', 'assalam', 'aoa', 'slam', 'hy'], a: function () { return { t: 'Wa Alaikum Assalam! 🐝 I\'m ' + name + '. Ask me about prices, delivery, how pure our honey is, or how to use it.' }; } },
      { k: ['price', 'prices', 'rate', 'cost', 'kitna', 'kitne', 'kitnay', 'qeemat', 'keemat', 'kimat', 'rupees', 'rs', 'how much', 'size', 'sizes', '250', '500', 'gram', 'gm'], a: function () { return { t: 'We have one honey in two squeeze-bottle sizes: ' + prices() + '. The 500g is our family favourite 🍯', acts: addActs() }; } },
      { k: ['delivery', 'deliver', 'shipping', 'ship', 'courier', 'charges', 'charge', 'kab', 'days', 'din', 'karachi', 'lahore', 'islamabad', 'rawalpindi', 'peshawar', 'quetta', 'multan', 'faisalabad', 'hyderabad', 'city', 'free'], a: function (q) {
        var t = 'We deliver all over Pakistan 🚚';
        if (/karachi/.test(q)) t += ' In Karachi, orders over ' + K + ' get FREE delivery.';
        else t += (K ? ' Free delivery in Karachi over ' + K + ',' : '') + (PK ? ' and FREE delivery anywhere in Pakistan over ' + PK + '.' : '');
        if (fee) t += ' Smaller orders pay ' + fee + ' delivery, shown at checkout.';
        return { t: t + ' Want an exact delivery time for your city? Ask us on WhatsApp.', acts: [{ wa: 'Hi! How long does delivery take to my city: ', label: 'Ask on WhatsApp' }] };
      } },
      { k: ['cod', 'cash', 'payment', 'pay', 'card', 'jazzcash', 'easypaisa', 'bank', 'transfer'], a: function () { return { t: 'Yes! Cash on Delivery is available, so you pay when your honey arrives 💵. Any other payment options are shown at checkout.' }; } },
      { k: ['pure', 'purity', 'asli', 'real', 'fake', 'khalis', 'original', 'certified', 'certificate', 'sfa', 'authority', 'sugar', 'mix', 'mixed', 'adulter', 'chemical', 'natural', 'organic', 'raw'], a: function () { return { t: 'Our honey is 100% pure, raw and natural, with no added sugar, syrup or preservatives. The Honey Squad is certified by the Sindh Food Authority ✅, and every bottle has a quality seal. Check it\'s intact before opening.' }; } },
      { k: ['where', 'kahan', 'source', 'sourced', 'north', 'northern', 'mountain', 'mountains', 'origin', 'from'], a: function () { return { t: 'Our honey comes from the northern areas of Pakistan 🏔️, where bees feed on wild mountain flowers. We keep it raw and unfiltered.' }; } },
      { k: ['gym', 'workout', 'protein', 'energy', 'fitness', 'exercise', 'run', 'running', 'sports'], a: function () { return { t: '💪 Gym crew favourite! Take a spoon about 30 minutes before training, stir it into oats, or squeeze it into your protein shake for natural energy. The 500g lasts longer.', acts: [{ add: '500', label: '🛒 Add 500g' }] }; } },
      { k: ['use', 'uses', 'how to use', 'recipe', 'recipes', 'eat', 'tea', 'chai', 'coffee', 'bread', 'toast', 'ice cream', 'icecream', 'cookies', 'paratha', 'pancake', 'dessert', 'yogurt', 'dahi', 'milk', 'doodh'], a: function () { return { t: 'Squeeze it on everything 🍯 Toast, paratha and pancakes, over ice cream, with cookies, in chai, green tea or coffee, in warm milk or dahi, and in your gym shake. No spoon needed: just flip the cap and squeeze!' }; } },
      { k: ['store', 'storage', 'fridge', 'refrigerate', 'crystal', 'crystallise', 'crystallize', 'jam', 'jamm', 'thick', 'solid', 'expiry', 'expire', 'shelf'], a: function () { return { t: 'Keep it at room temperature with the cap closed, away from sunlight. No fridge needed. Raw honey can crystallise in cool weather, which is natural. Stand the closed bottle in warm (not boiling) water and it turns runny again.' }; } },
      { k: ['baby', 'babies', 'infant', 'newborn', 'bacha', 'bachay', 'bachon', 'month old', 'months'], a: function () { return { t: 'Honey should not be given to babies under 12 months old. For older kids and the whole family it\'s a great treat! For health questions, please check with your doctor.' }; } },
      { k: ['kids', 'children', 'child', 'school', 'lunchbox'], a: function () { return { t: 'Kids love the squeeze bottle! Try it on toast or pancakes for breakfast, or in lunchbox sandwiches 🧒 (not for babies under 12 months).' }; } },
      { k: ['order', 'buy', 'purchase', 'kaise', 'kese', 'how to order', 'khareed', 'kharid', 'mangwana', 'checkout'], a: function () { return { t: 'Easy! Pick a size, tap Add to cart, then Checkout (Cash on Delivery available). Or order directly on WhatsApp' + (T.waDisplay ? ' at ' + T.waDisplay : '') + '.', acts: addActs().concat([{ wa: 'Assalam o Alaikum! I want to order honey.\nSize:\nQuantity:\nCity:', label: 'Order on WhatsApp' }]) }; } },
      { k: ['return', 'refund', 'broken', 'damaged', 'leak', 'leaking', 'wrong', 'complaint', 'problem', 'issue'], a: function () { return { t: 'Sorry to hear that! Please send us a photo of the bottle and your order number on WhatsApp and the team will sort it out quickly.', acts: [{ wa: 'Hi, I have an issue with my order. Order number: ', label: 'Message the team' }] }; } },
      { k: ['contact', 'number', 'whatsapp', 'call', 'phone', 'talk', 'human', 'agent', 'person'], a: function () { return { t: 'You can reach the team on WhatsApp' + (T.waDisplay ? ' or call ' + T.waDisplay : '') + ' 📞', acts: [{ wa: 'Assalam o Alaikum! ', label: 'Open WhatsApp' }] }; } },
      { k: ['discount', 'offer', 'deal', 'sale', 'coupon', 'promo', 'code', 'cheap'], a: function () { return { t: 'The best deal is free delivery: ' + (K ? 'orders over ' + K + ' in Karachi' : '') + (PK ? ' and over ' + PK + ' anywhere in Pakistan' : '') + ' ship free. Try our honey calculator to see how close you are!' }; } },
      { k: ['thanks', 'thank', 'shukriya', 'shukria', 'jazakallah', 'jazak', 'great', 'nice', 'ok', 'okay'], a: function () { return { t: 'Anytime! 🐝 Stay sweet. #HiveVibe' }; } }
    ];
    function answer(q) {
      var s = ' ' + q.toLowerCase().replace(/[^a-z0-9 ]/g, ' ') + ' ', best = null, score = 0;
      intents.forEach(function (it) {
        var sc = 0; it.k.forEach(function (k) { if (s.indexOf(' ' + k + ' ') > -1 || (k.length > 4 && s.indexOf(k) > -1)) sc += k.length > 3 ? 2 : 1; });
        if (sc > score) { score = sc; best = it; }
      });
      if (!best) return { t: 'Good question! I\'m not sure about that one, but the team can answer on WhatsApp in a few minutes 🐝', acts: [{ wa: q, label: 'Ask the team' }] };
      return best.a(s);
    }
    function bubble(html, me, acts) {
      var m = document.createElement('div'); m.className = 'msg ' + (me ? 'msg--me' : 'msg--bot');
      if (me) m.textContent = html; else m.innerHTML = html;
      if (acts && acts.length) {
        var w = document.createElement('div'); w.className = 'acts';
        acts.forEach(function (a) {
          var el;
          if (a.wa !== undefined) { el = document.createElement('a'); el.href = waLink(a.wa); el.target = '_blank'; el.rel = 'noopener'; el.className = 'wa'; }
          else { el = document.createElement('button'); el.type = 'button'; el.addEventListener('click', function () { var v = variantBy(a.add); if (v) addItems([{ id: v.id, quantity: 1 }], el); }); }
          el.textContent = a.label; w.appendChild(el);
        });
        m.appendChild(w);
      }
      log.appendChild(m); log.scrollTop = log.scrollHeight; return m;
    }
    function botSay(r) {
      var t = document.createElement('div'); t.className = 'msg msg--bot'; t.innerHTML = '<span class="typing"><i></i><i></i><i></i></span>';
      log.appendChild(t); log.scrollTop = log.scrollHeight;
      setTimeout(function () { t.remove(); bubble(r.t, false, r.acts); }, 450 + Math.min(900, r.t.length * 6));
    }
    function ask(q) { q = (q || '').trim(); if (!q) return; bubble(q, true); botSay(answer(q)); }
    form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); input.value = ''; });
    $$('[data-chat-chips] button', box).forEach(function (b) { b.addEventListener('click', function () { ask(b.textContent.replace(/^[^A-Za-z]+/, '')); }); });
    function open() {
      box.classList.add('is-open');
      if (!greeted) { greeted = true; botSay({ t: 'Assalam o Alaikum! 🐝 I\'m <b>' + name + '</b>, The Honey Squad\'s honey helper. Ask me anything, or tap a question below.' }); }
      setTimeout(function () { input.focus(); }, 300);
    }
    function close() { box.classList.remove('is-open'); }
    $$('[data-chat-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-chat-close]', box).forEach(function (b) { b.addEventListener('click', close); });
    return { open: open, close: close, ask: ask };
  })();
  window.HSChat = Chat;
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); if (mnav) mnav.classList.remove('is-open'); Chat.close(); } });
})();
